import Box from "@/ui/atoms/Box";
import { Icon, IconBox } from "@proda-ai/ui-kit";
import React from "react";

export type StatusBarProps = JSX.IntrinsicAttributes & {
    currentStep: number;
    steps: string[];
    onExit: () => void;
};

const StatusBar: React.FC<StatusBarProps> = ({
    currentStep,
    steps,
    onExit,
}) => {
    const backButtonWidth = "5%";
    const backButton = (
        <Box
            sx={{
                width: backButtonWidth,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
            }}
            onClick={onExit}
        >
            <Icon icon="xmark" />
        </Box>
    );

    return (
        <Box
            sx={{
                height: "5rem",
                display: "flex",
                backgroundColor: "var(--proda-white-110)",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "2rem",
            }}
        >
            {/* spacer so steps are centred */}
            <Box sx={{ width: backButtonWidth }} />
            <Box
                sx={{
                    height: "5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    padding: "1rem 2rem",
                }}
            >
                {steps.map((step, index) => (
                    <React.Fragment key={step}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                    backgroundColor:
                                        index + 1 <= currentStep
                                            ? "var(--proda-navy-blue)"
                                            : "var( --proda-black-10)",
                                    color: "white",
                                    marginRight: "0.5rem",
                                    fontWeight: "bold",
                                }}
                            >
                                {currentStep > index + 1 ? (
                                    <IconBox>
                                        <Icon icon="check" />
                                    </IconBox>
                                ) : (
                                    index + 1
                                )}
                            </Box>
                            <Box
                                component="span"
                                sx={{
                                    color:
                                        index + 1 <= currentStep
                                            ? "var(--proda-navy-blue)"
                                            : "var(--proda-black-10)",
                                    fontWeight:
                                        index + 1 <= currentStep
                                            ? "bold"
                                            : "normal",
                                }}
                            >
                                {step}
                            </Box>
                        </Box>
                        {index < steps.length - 1 && (
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    height: "2px",
                                    backgroundColor: "var(--proda-white-150)",
                                    margin: "0 0.5rem",
                                    maxWidth: "30%",
                                }}
                            />
                        )}
                    </React.Fragment>
                ))}
            </Box>
            {backButton}
        </Box>
    );
};

export default StatusBar;
